import { CataloguePickerParams, useCataloguePicker } from '@/hooks/use-catalogue-picker';

import {
  FeaturedPeoplePageParams,
  useInfiniteFeaturedPeople,
  useSelectedFeaturedPeople,
} from '../api/get-featured-people';
import { featuredPeopleQueryKeys } from '../api/query-keys';
import { TFeaturedPeopleType } from '../types';

type UsePeoplePickerParams = CataloguePickerParams & {
  range?: Omit<FeaturedPeoplePageParams, 'search'>;
};

const NO_RANGE = {};

export function usePeoplePicker({ range = NO_RANGE, ...picker }: UsePeoplePickerParams) {
  return useCataloguePicker<TFeaturedPeopleType, FeaturedPeoplePageParams>({
    ...picker,
    params: range,
    cacheKey: featuredPeopleQueryKeys.all,
    useInfinite: useInfiniteFeaturedPeople,
    useSelected: useSelectedFeaturedPeople,
  });
}
